import React from 'react';
import { IconProps } from './icons.models';

const InfoIcon: React.FC<IconProps> = ({
    width = 16,
    height = 16,
    fillColor = '#3B78CE',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_15_101863)">
                <path d="M8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 4.3168 11.6825 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654Z" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 10.6667V8" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 5.33203H8.00667" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_15_101863">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default InfoIcon;
